export default {
  install(Vue) {
    Vue.prototype.$copy = async function (value, notifyOptions = {}) {
      const text = value == null ? "" : String(value);
      let success = false;

      try {
        if (this && typeof this.$copyText === "function") {
          await this.$copyText(text);
          success = true;
        } else if (
          typeof navigator !== "undefined" &&
          navigator.clipboard &&
          typeof navigator.clipboard.writeText === "function"
        ) {
          await navigator.clipboard.writeText(text);
          success = true;
        } else {
          const input = document.createElement("textarea");
          input.value = text;
          input.setAttribute("readonly", "");
          input.style.position = "absolute";
          input.style.left = "-9999px";
          document.body.appendChild(input);
          input.select();
          success = document.execCommand("copy");
          document.body.removeChild(input);
        }
      } catch (e) {
        success = false;
      }

      const successMessage = notifyOptions.successMessage || "复制成功";
      const errorMessage = notifyOptions.errorMessage || "复制失败！";
      const duration = notifyOptions.duration || 1000;

      if (this && typeof this.$tbMessage === "function") {
        this.$tbMessage({
          type: success ? "success" : "error",
          text: success ? successMessage : errorMessage,
          duration,
        });
      }

      return success;
    };
  },
};
